import axios from 'axios';
import APIS from '../../apis/notLogin';
import WEIOAPI from '@/apis/weibo.js'
import qs from 'qs';
import {
  callbackHandler,
  YIAPIcallbackHandler,
} from '../callbackHandler';

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 免登+先测试后付费（for微博） 获取测评价格
    notloginGetScalePrice(context, params) {
      console.log('--- getScalePrice ---', params);
      return axios.get(APIS.getScalePrice, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getScalePrice, res);
        return res.data;
      })
    },
    // 免登+先测试后付费支付接口
    notloginPay(context, {API,params}) {
      return axios.get(API, {
        params: params
      }).then(function (res) {
        callbackHandler(APIS.payOrder, res);
        return res.data;
      })
    },
    notloginGetQrcode(context, params) {
      console.log('--- getQrcode ---', params);
      return axios.get(APIS.getQrcode, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.getQrcode, res);
        return res.data;
      })
    },
    // 免登+先测试后付费（for微博） 获取测评价格
    availableActivityCard(context, params) {
      return axios.get(APIS.availableActivityCard, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.availableActivityCard, res);
        return res.data;
      })
    },

    handleWeiboAuth(context, params) {
      return axios.get(WEIOAPI.weiboAuth, {
        params: params.params
      }).then(function (res) {
        callbackHandler(WEIOAPI.weiboAuth, res);
        return res.data;
      })
    },

    validatePhone(context, params) {
      return axios.post(APIS.validatePhone, qs.stringify(params.params)).then(res => {
        callbackHandler(APIS.validatePhone, res);
        return res.data;
      })
    },

    cepingVipBindPhone(context, params) {
      return axios.post(APIS.cepingVipBindPhone, qs.stringify(params.params)).then(res => {
        callbackHandler(APIS.cepingVipBindPhone, res);
        return res.data;
      })
    },
    cepingVipBindPhone4(context, params) {
      return axios.post(APIS.cepingVipBindPhone4, qs.stringify(params.params)).then(res => {
        callbackHandler(APIS.cepingVipBindPhone4, res);
        return res.data;
      })
    },
    cepingVipBindTfPhone4(context, params) {
      return axios.post(APIS.cepingVipBindTfPhone4, qs.stringify(params.params)).then(res => {
        callbackHandler(APIS.cepingVipBindTfPhone4, res);
        return res.data;
      })
    },

    searchOrderDoAfterBuyNew(context, params) {
      return axios.get(APIS.searchOrderDoAfterBuyNew, { params: params.params}).then(res => {
        callbackHandler(APIS.searchOrderDoAfterBuyNew, res);
        return res.data;
      })
    },

    existOrder(context, params) {
      return axios.get(APIS.existOrder, { params: params.params}).then(res => {
        callbackHandler(APIS.existOrder, res);
        return res.data;
      })
    },

    // 获取投放分流类型
    getSplitFlowType(context, params) {
      return axios.get(APIS.splitFlowType, {
        params: params.params
      }).then(function (res) {
        callbackHandler(APIS.splitFlowType, res);
        return res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notLogin.js